import type { ComputedRef } from 'vue'
import type { DemandeActions } from '../shared'
import type { SalarieRechercheDTO } from '@/features/api/extranet/dto/Demande/shared/SalarieRechercheDTO'

export const CPRO_INJECT = Symbol('cpro-inject')

export type DemandeCproActions = {
  alertPlus26AnsLabel: ComputedRef<string | undefined>,
  patchRemplacerSalarié: (salarieRecherché: SalarieRechercheDTO) => Promise<void> | void
} & DemandeActions
